import { PageWrapper } from "@/components/page-wrapper";
import { FC, useContext } from "react";
import { NewsList } from "./components/news-list";
import styles from "./styles.scss";
import { NewsBoard } from "@/pages/home/components/news-board";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  EmptyDataScreen,
  ErrorScreen,
  ImageLoader,
  Loader,
} from "@/components";
import { useNavigate } from "react-router-dom";
import { ApprovalsTab, BasicRoutePath } from "@/constants";
import { AuthContext } from "@/guards/auth/auth-context";
import { useNewsList } from "@/pages/home/hooks/use-news-list";
import { usePageContent } from "@/pages/home/hooks/use-page-content";
import { BANNER_IMG } from "@/pages/home/constants";

export const HomePage: FC = () => {
  const navigate = useNavigate();
  const { account } = useContext(AuthContext);

  const { isLoadingNewsList, newsList, errorNewsList } = useNewsList(account);

  const { isLoadingPageContent, pageContent, errorPageContent } =
    usePageContent(account);

  const pageIsLoading =
    (isLoadingNewsList && !newsList?.length) ||
    (isLoadingPageContent && !pageContent?.length);

  const handleNavigateToTrackRequest = () => {
    navigate(`${BasicRoutePath.Approvals}/${ApprovalsTab.Tracking}`);
  };

  const handleNavigateToCreateRequest = () => {
    navigate(`${BasicRoutePath.Requests}`);
  };

  const renderContent = () => {
    if (errorNewsList || errorPageContent) {
      return (
        <ErrorScreen
          subtitle="Can't loading news page"
          error={errorNewsList || errorPageContent}
        />
      );
    }

    if (!newsList?.length && !pageContent?.length) {
      return <EmptyDataScreen />;
    }

    return (
      <>
        <div className={styles.bannerWrapper}>
          <div className={styles.banner}>
            <ImageLoader src={BANNER_IMG} />
          </div>
        </div>

        {!!newsList?.length && <NewsList data={newsList} />}

        {!!pageContent?.length && <NewsBoard data={pageContent} />}

        <div className={styles.actionButtons}>
          <Button
            variant={ButtonVariant.Secondary}
            size={ButtonSize.Large}
            type="submit"
            className={styles.actionButton}
            onClick={handleNavigateToTrackRequest}
          >
            Track current requests
          </Button>

          <Button
            variant={ButtonVariant.Primary}
            size={ButtonSize.Large}
            type="submit"
            className={styles.actionButton}
            onClick={handleNavigateToCreateRequest}
          >
            Create new request
          </Button>
        </div>
      </>
    );
  };

  return (
    <PageWrapper
      title="ADNOC Letter of Assistance"
      pageWrapperTitleClassName={styles.mainTitle}
    >
      {pageIsLoading ? (
        <div>
          <Loader />
        </div>
      ) : (
        renderContent()
      )}
    </PageWrapper>
  );
};
